import axiosInstance from './axiosInstance';

const getHealth = async () => {
    const response = await axiosInstance.get('/actuator/health');
    return response.data;
};

const getInfo = async () => {
    const response = await axiosInstance.get('/actuator/info');
    return response.data;
};

const getMetrics = async () => {
    const response = await axiosInstance.get('/actuator/metrics');
    return response.data;
};

const getSpecificMetric = async (metricName) => {
    const response = await axiosInstance.get(`/actuator/metrics/${metricName}`);
    return response.data;
};

const recalculateAchievements = async () => {
    const response = await axiosInstance.post('/admins/recalculate-achievements');
    return response.data;
};

const runPredictionReminders = async () => {
    const response = await axiosInstance.post('/admins/run-prediction-reminders');
    return response.data;
};

const refreshStandings = async (tournamentId) => {
    const response = await axiosInstance.post(`/admins/refresh-standings/${tournamentId}`);
    return response.data;
};

const refreshPredictionsForMatch = async (matchId) => {
    const response = await axiosInstance.post(`/admins/matches/${matchId}/refresh-predictions`);
    return response.data;
};

const recalculatePointsForMatch = async (matchId) => {
    const response = await axiosInstance.post(`/admins/matches/${matchId}/recalculate-points`);
    return response.data;
};

const getRecalculableMatchesForTournament = async (sportType, tournamentId) => {
    const response = await axiosInstance.get(
        `/admins/tournaments/${tournamentId}/recalculable-matches`,
        { params: { sportType } }
    );
    return response.data;
};

const getEditableMatches = async () => {
    const response = await axiosInstance.get('/admins/editable-matches');
    return response.data;
};

const updateMatchDataFromApi = async (matchId) => {
    const response = await axiosInstance.post(`/admins/matches/${matchId}/update-data`);
    return response.data;
};

export default {
    getHealth,
    getInfo,
    getMetrics,
    getSpecificMetric,
    recalculateAchievements,
    runPredictionReminders,
    refreshStandings,
    refreshPredictionsForMatch,
    recalculatePointsForMatch,
    getRecalculableMatchesForTournament,
    getEditableMatches,
    updateMatchDataFromApi
};